import React from 'react'
import { AnchorLink } from '../../common'
import selectn from 'selectn'

export const ScorecardSummary = ({
  fullSummaryLink = '',
  innings = {},
  isLimitedOvers
}) => {

  const content = (
    <article className="sub-module scorecard-summary">
      <header className="bordered">
        <h1>Scorecard Summary</h1>
      </header>
      <div className="content">
        {
          Object.keys(innings).map((innCount, i) => {
            const { team, batsmen, bowlers } = innings[innCount]
            return (
              <div key={i} className="inning">
                { team &&
                  <h4>
                    <x-span>{team.teamDisplayName} {team.inningsRunWicket}</x-span>
                    {
                      team.overs &&
                      <span>({team.overs} OVERS)</span> || null
                    }
                    { isLimitedOvers ? '' :
                      <div className="innings">{team.innDisplayName}</div>
                    }
                  </h4>
                }
                <ul className="two-col-table">
                  { batsmen &&
                    batsmen.map((b, j) => {
                      const stats = b.stats || {}
                      // Need to show * for not out player
                      const isNotOut = selectn('notouts.value', stats) == '1' ? true : false
                      const runsScored = selectn('runs.value', stats)
                      const ballsFaced = selectn('ballsFaced.value', stats)
                      const batsmanName = (b.name) ? b.name : ''
                      const batsmanLink = (
                        batsmanName ?
                        <a href={b.href}>{batsmanName}{isNotOut ? '*' : null}</a>
                        :
                        <a>-</a>
                      )
                      return (
                        <li key={j}>
                          {batsmanLink}
                          {
                            runsScored && ballsFaced &&
                            <span>{runsScored} ({ballsFaced})</span> || null
                          }
                          
                        </li>
                      )
                    })
                  }
                </ul>
                <ul className="two-col-table">
                  { bowlers &&
                    bowlers.map((b, j) => {
                      const stats = b.stats || {}
                      const wicketsTaken = selectn('wickets.value', stats)
                      const runsConceded = selectn('conceded.value', stats)
                      const oversBowled = selectn('overs.value', stats)
                      const bowlerName = (b.name) ? b.name : ''
                      const bowlerLink = (
                        bowlerName ?
                        <a href={b.href}>{b.name}</a>
                        :
                        <a>-</a>
                      )
                      return (
                        <li key={j}>
                          {bowlerLink}
                          {
                            wicketsTaken && oversBowled && 
                            <span>{wicketsTaken}/{runsConceded} ({oversBowled})</span> || null
                          }
                        </li>
                      )
                    })
                  }
                </ul>
              </div>
            )
          })
        }
      </div>
      <footer>
        {
          fullSummaryLink &&
          <AnchorLink to={fullSummaryLink} text="Full Scorecard" />
        }
      </footer>
    </article>
  )

  return Object.keys(innings).length ? content : <article style={{ display: 'none' }} className="sub-module scorecard-summary"/>
}

export default ScorecardSummary



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/cricket/ScorecardSummary.jsx
 **/